import React, { useEffect, useState } from 'react';
import { CircularProgress, CssBaseline, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import SignupButton from '../../auth/components/signup-button';
import LoginButton from '../../auth/components/login-button';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
	root: {
		height: '100vh',
	},
	image: {
		backgroundImage: "url('https://hammurabi-app.s3.ca-central-1.amazonaws.com/public/iStock-1068078956.jpeg')",
		backgroundRepeat: 'no-repeat',
		backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	},
	paper: {
		paddingTop: 40,
		alignItems: 'center',
		textAlign: 'center',
		width: '90%',
		margin: 'auto',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},

	logo: {
		maxWidth: '400px',
	},
}));

function Auth0({ isLoading, isAuthenticated, urlToRedirect }) {
	const classes = useStyles();
	const [bgNumber, setBgNumber] = useState(null);

	useEffect(() => {
		if (!bgNumber) {
			const rndInt = Math.floor(Math.random() * 6) + 1;
			setBgNumber(rndInt);
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (isLoading) {
		return (
			<div className='flex h-screen'>
				<div className='m-auto'>
					<CircularProgress />
				</div>
			</div>
		);
	}

	return (
		<Grid container component='main' className={classes.root}>
			<CssBaseline />
			<Grid item xs={false} sm={4} md={7} className={clsx(``, classes.image)} />
			<Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
				<Grid item className={classes.paper}>
					<img
						src='/assets/img/logo.png'
						alt='simply borrowed logo'
						className={classes.logo}
						style={{ margin: 'auto' }}
					/>
					{isLoading ? (
						<Grid item xs={12}>
							<CircularProgress />
						</Grid>
					) : (
						<Grid item container className={classes.paper}>
							<Grid item xs={12}>
								<Typography variant='body2'>
									In order to continue you can create a account by signing up
								</Typography>
							</Grid>
							<Grid item xs={12}>
								<SignupButton />
							</Grid>
							<Grid item xs={12}>
								<Typography variant='body2'>Or if you already have an account you can Login</Typography>
							</Grid>
							<Grid item xs={12}>
								<LoginButton  urlToRedirect={urlToRedirect} />
							</Grid>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}

export default Auth0;
